import { Board, Column } from '@gamma/ui/layout';

import { useContext } from 'react';
import { AuthContext } from '../../../shared/providers/AuthProvider/AuthContext';
import {
  APIKeysDashboard,
  DetectionSettingsDashboard,
  LicenseDashboard,
  TenantSettingsDashboard,
} from '../components';

export const General = () => {
  const { isOrgTenant } = useContext(AuthContext);
  return (
    <Board>
      {!isOrgTenant && (
        <Column>
          <APIKeysDashboard />
        </Column>
      )}
      <Column>
        <TenantSettingsDashboard />
      </Column>
      {!isOrgTenant && (
        <Column>
          <DetectionSettingsDashboard />
        </Column>
      )}
      <Column>
        <LicenseDashboard />
      </Column>
    </Board>
  );
};
